import { render, staticRenderFns } from "./tile-customers.vue?vue&type=template&id=7d5f4459&"
import script from "./tile-customers.vue?vue&type=script&lang=js&"
export * from "./tile-customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports